module.exports = __webpack_public_path__ + "img/ic-certificate.7c6e8f4c.svg";